import styled from '@emotion/styled';

export const InputContainer = styled.div`
	width: 100%;
	padding: var(--padding-2);

	> .integer-input-container {
		width: 100%;
	}

	&.table-float-input-container {
		display: flex;
		gap: 1rem;
	}
`;
